<template>
    
    <div class="wrap">
        <rotate-detect></rotate-detect><!--  template   -->
        
        <div class="topbar"></div>
        <div class="rightbar"></div>
        <div class="content">
            <nav-bar :nav="showNav"></nav-bar><!--  template   -->
            <section class="artistpage">
              <div class="block"><svg class="svg100" ratio="0.25" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 480"><title>blockwhite</title><polygon points="1920 0 0 480 0 0 1920 0" /></svg></div>
              <div class="main">
                <div class="bookmark"><img src="../asset/svg/bookmark/v/artist.svg" alt="多寶創作人"></div>
                <div class="max1000"><a href="/#/?from_artist" class="arrow_back" onclick="gaclick('btn_artist_back')">
                    <svg class="arrowtop" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.86 18.28"><title>top</title><path d="M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z" /></svg>
                    <svg class="arrowbg"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
                  <h2 class="artistdescription wow1 fadeInUp"><img src="../img/artist/artistpage2.svg" alt="美是一種本能"></h2>
                  <div class="artistinfo">
                    <div class="artistpic wow1 fadeInUp"><img src="../img/artist/artist02.jpg"></div>
                    <div class="txtcontent strip">
                      <h2 class="wow2 fadeInUp"><span>創作人/</span><b>林佳瑄</b></h2>
                      <p class="wow3 fadeInUp">四歲時的佳瑄，每到一個新的空間常哭鬧不停。出門更是困難，一定要選到她滿意的衣服、裙褲、鞋子，包括顏色的搭配才願意出門。所有的孩子，只有她看到韓老師換了新的背包，還要老師背起來，轉身換角度讓她欣賞。時間讓一個孩子長大，但天生的本質一直在，延伸對時尚造型彩妝的興趣，生活的基本是要漂亮、好看。</p>
                    </div>
                  </div>
                  <div class="worklist">
                    <ul>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work02_1.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">喜馬拉雅藍罌粟</h3>
                        <p class="wow3 fadeInUp">27.2(L) x 39.3(M)cm (8K) 水彩 2016.</p>
                      </li>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work02_2.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">林佳瑄自畫像</h3>
                        <p class="wow3 fadeInUp">54.5(L) x 39.3(M)cm (4K) 鉛筆 2015.</p>
                      </li>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work02_3.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">紫丁香</h3>
                        <p class="wow3 fadeInUp">27.2(L) x 39.3(M)cm (8K) 水彩 2016.</p>
                      </li>
                    </ul>
                  </div><a href="javascript:void(0)" class="btn wow4 fadeInUp" onclick="trackWaitJump('btn_moreworks_linjiaxuan','https://taiwancurio.wordpress.com/category/%E6%9E%97%E4%BD%B3%E7%91%84/')">
                    <!--blogicon-->
                    <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.24 35.64"><title>read</title><path d="M36.64,0H23.83a4.64,4.64,0,0,0-3.2,1.33A4.64,4.64,0,0,0,17.42,0H4.6A4.67,4.67,0,0,0,0,4.6V27.83a4.67,4.67,0,0,0,4.6,4.6H17.42a1.78,1.78,0,0,1,1.8,1.8,1.4,1.4,0,0,0,1.4,1.4,1,1,0,0,0,.41-.07,1.28,1.28,0,0,0,.82-.63,1.25,1.25,0,0,0,.17-.7,1.78,1.78,0,0,1,1.8-1.8H36.64a4.67,4.67,0,0,0,4.6-4.6V4.6A4.67,4.67,0,0,0,36.64,0ZM22,4.6a1.78,1.78,0,0,1,1.8-1.8H36.64a1.78,1.78,0,0,1,1.8,1.8V27.83a1.78,1.78,0,0,1-1.8,1.8H23.83A4.18,4.18,0,0,0,22,30Zm-2.8,0V30a4.18,4.18,0,0,0-1.8-.41H4.6a1.78,1.78,0,0,1-1.8-1.8V4.6A1.78,1.78,0,0,1,4.6,2.8H17.42A1.78,1.78,0,0,1,19.22,4.6Z" /></svg></div><span>更多佳瑄的事</span></a>
                </div>
              </div>
              <div class="switchbtn"><router-link to="/artist1" class="btn artist1">
                  <p> <span>創作人/</span><b>吳柏均</b></p></router-link><router-link to="/artist3" class="btn artist3">
                  <p><span>創作人/</span><b>高健騰</b></p></router-link></div>
            </section>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import ScrollReveal from 'scrollreveal'
    
    import navBar from './common/Nav.vue'
    import rotateDetect from './common/RotateDetect.vue'

    export default {
      components: {
          navBar,
          rotateDetect
      },
      data: function() {
            return {
               showNav:false
            }
      },
      mounted: function(){
          window.sr = ScrollReveal({ reset: true });
            // Customizing a reveal set
          var vv = function(ele,dur,del){
              sr.reveal(ele, { 
                  origin: 'bottom',
                  duration: dur,
                  delay: del,
                  opacity: 0,
                  scale: 1,
                  easing: 'cubic-bezier(0.42, 0, 0.58, 1)',
                  // mobile: true
              });
          }
          vv('.wow1',500,0);
          vv('.wow2',500,200);
          vv('.wow3',500,400);
          vv('.wow4',500,600);
          $('.main').animate({opacity:1});
          $('.logo').on('click',function(){
              window.location="/#/?from_artist";
              gaclick('btn_logo');
          });
          
          gapage('pv_linjiaxuan');
      },
      created: function() {
            //Scrolls to top when view is displayed
            window.scrollTo(0, 0);
      }
    }
</script>

<style>
    @import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css';
</style>


// WEBPACK FOOTER //
// Artist2.vue?c413bdc0